import Location from '@/gis/Location'
import Rect from '@/model/Rect'
import OSMTile from '@/model/OSMTile'
import MathUtils from './MathUtils';

var OSMUtils = {

    toLocationFromXYZoom: function(x, y, zoom) {
		const latitude = OSMUtils.tile2Latitude(y, zoom);
		const longitude = OSMUtils.tile2Longitude(x, zoom);
		
		return new Location(latitude, longitude, 0);
	},
	
	toLocationFromOSMTile: function(osmTile) {
		return osmTile != null ? OSMUtils.toLocationFromXYZoom(osmTile.x, osmTile.y, osmTile.zoom) : null;
	},
	
	fromLocation: function(location, zoom) {
		var x = Math.floor(OSMUtils.longitude2Tile(location.longitude, zoom));
		var y = Math.floor(OSMUtils.latitude2Tile(location.latitude, zoom));
		if (x < 0) {
			x = 0;
		}
		if (x >= (1<<zoom)) {
			x = ((1<<zoom)-1);
		}
		if (y < 0) {
			y = 0;
		}
		if (y >= (1<<zoom)) {
			y = ((1<<zoom)-1);
		}
		
		return new OSMTile(x, y, zoom);
	},
	
	computeLatLngBounds: function(topLeft, bottomRight) {
		const topLeftLocation = OSMUtils.toLocationFromOSMTile(topLeft);
		const bottomRightLocation = OSMUtils.toLocationFromOSMTile(bottomRight);
		
		const bounds = new Rect();
		bounds.top = topLeftLocation.latitude;
		bounds.left = topLeftLocation.longitude;
		bounds.bottom = bottomRightLocation.latitude;
		bounds.right = bottomRightLocation.longitude;
		
		return bounds;
	},

	longitude2Tile: function(longitude, zoom) {
		return Math.floor((longitude + 180.0) / 360.0 * (1<<zoom));
	},
	
	latitude2Tile(latitude, zoom) {
		return Math.floor((1.0 - Math.log(Math.tan(MathUtils.toRadians(latitude)) + 1 / Math.cos(MathUtils.toRadians(latitude))) / Math.PI) / 2 * (1<<zoom));
	},
	
	tile2Longitude(x, zoom) {
		return x / Math.pow(2.0, zoom) * 360.0 - 180.0;
	},
	
	tile2Latitude(y, zoom) {
		const n = Math.PI - 2.0 * Math.PI * y / Math.pow(2.0, zoom);
		return 180.0 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)));
	},
	
	zoomFromZoomScale: function(zoomScale, baseZoom) {
		if (zoomScale < 1.0) {
			var nbSteps = 0;
			for (var scale = 1.0; scale > zoomScale;) {
				scale = scale / 2;
				nbSteps = nbSteps + 1;
				
				if (nbSteps >= baseZoom) {
					break;
				}
			}
			var osmZoom = baseZoom - nbSteps;
			if (osmZoom < 0.0) {
				osmZoom = 0.0;
			}
			return osmZoom;
		} else if (zoomScale > 1.0) {
			const osmZoom = baseZoom + (zoomScale - 1.0);
			return osmZoom;
		} else {
			return baseZoom;
		}
	}
}

export default OSMUtils;